export const getContact = (contactId) => ({ contacts }) =>
contacts.contactsList.find(({ id }) => id === contactId);